<script setup lang="ts" generic="T extends { id: number }">
  import { useSearchGlobalStore } from '@/stores/search-global'
  import SearchResultGroupItem from './search-result-group-item.vue'

  const searchGlobal = useSearchGlobalStore()

  defineProps<{
    name: string,
    items: T[],
    routeDetail?: string,
    routeList: string,
  }>()
</script>

<template>
  <div>
    <div class="px-2 pt-2 text-primary font-bold">
      {{ name }}
    </div>
    <div class="divide-y">
      <search-result-group-item
        v-for="item in items"
        :key="item.id"
        :to="{ name: routeDetail, params: { id: item.id } }">
        <slot :item="item"></slot>
      </search-result-group-item>
    </div>

    <template v-if="items.length === 0">
      <div class="my-2 px-2 flex items-center text-sm text-gray-400">
        Tidak ada data
      </div>
    </template>

    <search-result-group-item
      v-if="items.length > 0"
      class="mb-2"
      :to="{ name: routeList, query: { cari: searchGlobal.search } }">
      <app-button class="btn-link text-sm">
        Lihat lebih banyak {{ name }}
      </app-button>
    </search-result-group-item>
  </div>
</template>
